class VwStkGirishareketDTO {
    id?: number = null;
    depodonemId?: number = null;
    tarih?: string = null;
    islemtipId?: number = null;
    kurumId?: number = null;
    gonderenorganizasyonId?: number = null;
    gonderenservisId?: number = null;
    hastamuracaatId?: number = null;
    faturatarih?: string = null;
    faturaNo?: string = "";
    irsaliyetarih?: string = null;
    irsaliyeNo?: string = "";
    sorumlupersonelId?: number = null;
    faturaindirimtutar?: number = null;
    aciklama?: string = "";
    cikisaktif?: string = "";
    teslimedenad?: string = "";
    teslimalanad?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    iptalaciklama?: string = "";
    depotanimId?: number = null;
    islemtanimId?: number = null;
    birimucret?: number = null;
    kdvOran?: number = null;
    indirimoran?: number = null;
    indirimtutar?: number = null;
    miktar?: number = null;
    anamiktar?: number = null;
    kdvtoplam?: number = null;
    geneltoplam?: number = null;
    lotserino?: string = "";
    detayeklemeTarihi?: string = null;
    orgAdi?: string = "";
    kurumAdi?: string = "";
    gonderenservisAdi?: string = "";
}
export default VwStkGirishareketDTO;